import axios from '../../../api/axios'

export const APPROVER_ENDPOINTS = {
  BASE: "approvers",
};

/**
 * Central error handler
 */
const handleApiError = (error, defaultMessage) => {
  const message = error?.response?.data?.message || error.message || defaultMessage;
  throw new Error(message);
};

/**
 * Create new approver
 */
export const createApprover = async (payload) => {
  try {
    const response = await axios.post(APPROVER_ENDPOINTS.BASE, payload);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to create approver");
  }
};

/**
 * Update an existing approver
 */
export const updateApprover = async (id, payload) => {
  try {
    const url = `${APPROVER_ENDPOINTS.BASE}/${id}`;
    const response = await axios.put(url, payload);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to update approver");
  }
};

/**
 * Delete an approver
 */
export const deleteApprover = async (id) => {
  try {
    const url = `${APPROVER_ENDPOINTS.BASE}/${id}`;
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to delete approver");
  }
};

/**
 * Fetch all approvers (optionally filter by company_id)
 */
export const getAllApprovers = async (company_id) => {
  try {
    const response = await axios.get(APPROVER_ENDPOINTS.BASE, {
      params: { company_id },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch approvers");
  }
};

/**
 * Fetch a single approver by ID
 */
export const getApproverById = async (id) => {
  try {
    const url = `${APPROVER_ENDPOINTS.BASE}/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch approver");
  }
};